import { useTranslation } from "react-i18next";
import { Button } from "@/components/shared/ui/button";
import { Languages } from "lucide-react";
import { logger } from "@/lib/logger";

// Interactive language selector (toggles between Danish and English)
export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const current = i18n?.language || "da";
  const isDanish = current.startsWith("da");

  const handleToggle = async () => {
    try {
      await i18n.changeLanguage(isDanish ? "en" : "da");
    } catch (err) {
      // Swallow errors - not critical for UI; log for diagnostics
      logger.error("Language change error", err as Error);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className="gap-2 min-h-[44px] min-w-[44px] px-3"
      data-testid="language-selector"
      onClick={handleToggle}
      aria-label={isDanish ? "Switch to English" : "Skift til dansk"}
    >
      <Languages className="h-4 w-4" />
      <span className="sm:inline">{isDanish ? "🇩🇰" : "🇬🇧"}</span>
      <span className="hidden md:inline">{isDanish ? "Dansk" : "English"}</span>
    </Button>
  );
};
